<div>
  <div class="tab">
    @if (hasResourcesForTab('network')) {
      <button type="button" id="network-tab" [ngClass]="{ active: isActiveTab('network') }" (click)="setTab('network')">
        <h3 [ngClass]="{ inactive: !isActiveTab('network') }">Network</h3>
      </button>
    }
    @if (hasResourcesForTab('compute')) {
      <button type="button" id="compute-tab" [ngClass]="{ active: isActiveTab('compute') }" (click)="setTab('compute')">
        <h3 [ngClass]="{ inactive: !isActiveTab('compute') }">Compute</h3>
      </button>
    }
    @if (hasResourcesForTab('storage')) {
      <button type="button" id="storage-tab" [ngClass]="{ active: isActiveTab('storage') }" (click)="setTab('storage')">
        <h3 [ngClass]="{ inactive: !isActiveTab('storage') }">Storage</h3>
      </button>
    }
    @if (hasResourcesForTab('k8s')) {
      <button type="button" id="k8s-tab" [ngClass]="{ active: isActiveTab('k8s') }" (click)="setTab('k8s')">
        <h3 [ngClass]="{ inactive: !isActiveTab('k8s') }">Kubernetes</h3>
      </button>
    }
    @if (hasResourcesForTab('ai')) {
      <button type="button" id="ai-tab" [ngClass]="{ active: isActiveTab('ai') }" (click)="setTab('ai')">
        <h3 [ngClass]="{ inactive: !isActiveTab('ai') }">AI</h3>
      </button>
    }
    @if (hasResourcesForTab('other')) {
      <button type="button" id="other-tab" [ngClass]="{ active: isActiveTab('other') }" (click)="setTab('other')">
        <h3 [ngClass]="{ inactive: !isActiveTab('other') }">Other</h3>
      </button>
    }
  </div>
  <div id="resource-selector-box" class="with-tabs">
    @if (!readonly && refreshing && sourceResources && sortedResourcesByType.length === 0) {
      <div class="loading-message">
        <i class="fa-solid fa-spinner fa-spin"></i> Querying primary environment for resources...
      </div>
    } @else {
      @if (sortedResourcesByType.length === 0 && readonly) {
        <div class="no-resources-message">No resources configured for this application.</div>
      }
      @if (sortedResourcesByType.length === 0 && !readonly && !refreshing) {
        <!-- Distinguish between "no resources discovered" and "error loading" -->
        @if (sourceResources && sourceResources.size === 0) {
          <div class="no-resources-message">
            No supported resources were found in the connected account. Verify the account has supported resource types
            and click RESCAN.
          </div>
        } @else {
          <div class="no-resources-message">
            Unable to load resources.
            @if (viewIssues.observed) {
              <a class="issues-link" (click)="viewIssues.emit()">Check the Issues tab</a>
              for details, then click RESCAN.
            }
            @if (!viewIssues.observed) {
              Click RESCAN to retry.
            }
          </div>
        }
      }
      @for (resourceTypeData of sortedResourcesByType; track resourceTypeData) {
        <div class="resource-type" id="navattic-resource-type-container">
          <span class="resource-type-name">
            {{ getResourceTypePluralDisplayText(resourceTypeData.resourceTypeDetails) }}
            @if (resourceSupportsRealTimeReplication(resourceTypeData.resourceTypeDetails)) {
              <span class="real-time-replicated">(Real-time Replicated)</span>
            }
          </span>
          @if (resourceTypeData.nodes.length <= 1000) {
            <div class="tree-root">
              @for (node of resourceTypeData.nodes; track nodeTrackBy($index, node)) {
                <tree-node
                  [node]="node"
                  [displayChildren]="true"
                  [readonly]="readonly"
                  (selectionChange)="onNodeSelectionChanged($event)"
                  (expand)="onNodeExpanded($event)"
                  (collapse)="onNodeCollapsed($event)"
                ></tree-node>
              }
            </div>
          }
          @if (resourceTypeData.nodes.length > 1000) {
            <p-scroller
              [items]="resourceTypeData.nodes"
              [itemSize]="36"
              scrollHeight="600px"
              [style]="{ width: '100%', height: '600px' }"
              styleClass="tree-root"
            >
              <ng-template #item let-node>
                <tree-node
                  [node]="node"
                  [readonly]="readonly"
                  (selectionChange)="onNodeSelectionChanged($event)"
                  (expand)="onNodeExpanded($event)"
                  (collapse)="onNodeCollapsed($event)"
                ></tree-node>
              </ng-template>
            </p-scroller>
          }
        </div>
      }
    }
  </div>
</div>
